<template>
  <el-table-column
    prop="is_active"
    label="Aktív"
    sortable="custom"
    min-width="100"
    show-overflow-tooltip
  >
    <template slot-scope="scope">
      {{ scope.row.is_active ? 'Igen' : 'Nem' }}
    </template>
  </el-table-column>
</template>

<script>
  export default {
    propName: 'is_active',
  };
</script>
